/** Stable keys for POST /api/hosting/visits — must match Hub, hosted-site beacons, and faircorp-api. */
export const VISIT_KEY_FAIRCORP_HUB = 'faircorp-hub';
export const VISIT_KEY_FAIRCORP_HOSTING = 'faircorp-hosting';
export const VISIT_KEY_FAIRCORP_TOOLBOX = 'faircorp-toolbox';
export const VISIT_KEY_FAIRCORP_CLOUD = 'faircorp-cloud';
/** S&O Prime Detailing — must match `js/hosting-visit.js` on the hosted site. */
export const VISIT_KEY_PRIME_DETAILING = 'prime-detailing';
export const VISIT_KEY_COFFEECHAT = 'coffeechat';
export const VISIT_KEY_YOUTH_MEDICAL_OUTREACH = 'youth-medical-outreach';
